import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { SnUser } from './user';

export class UserMfaDevice extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  @Type(() => SnUser)
  public user: SnUser;

  @Expose()
  public name: string;

  @Expose()
  public password: string;

  @Expose()
  public confirmed: boolean;

  @Expose()
  public throttlingFailureTimestamp: string;

  @Expose()
  public throttlingFailureCount: number;

  @Expose()
  public key: string;

  @Expose()
  public step: number;

  @Expose()
  public tO: number;

  @Expose()
  public digit: number;

  @Expose()
  public tolerance: number;

  @Expose()
  public drift: number;

  @Expose()
  public lastT: number;

  @Expose()
  public configUrl: string;

  @Expose()
  public totpToken: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
